import { ControlLayout } from 'components/ControlLayout';
import { RefinancingPersonalInfoForm } from 'components/refinancing/RefinancingPersonalInfoForm';
import { RefinancingVehicleForm } from 'components/refinancing/RefinancingVehicleForm';
import { LoadingModal } from 'components/response/LoadingModal';
import { StageBar } from 'components/StageBar';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import { LOAN_ACTIONS } from 'constants/LoanActions';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import { FormContext } from 'context/FormContext';
import { useLoanFormContainerControl } from 'hooks/useLoanFormContainerControl';
import { useLogin } from 'hooks/useLogin';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import checkIsMobile from 'utils/CheckIsMobile';

const config = [
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Comenzar',
		backAction: LOAN_ACTIONS.BACK_TO_HOME,
		nextAction: LOAN_ACTIONS.NEXT_STEP,
	},
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Continuar',
		backAction: LOAN_ACTIONS.BACK_STEP,
		nextAction: LOAN_ACTIONS.SAVE_FORM_AND_CALL_REFINANCING_SERVICE,
	},
];

export const RefinancingContainer = () => {
	const history = useHistory();

	const [login] = useLogin();

	const [formData, setformData] = useState({});
	const {
		executeAction,
		step,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
		showLongModal,
	} = useLoanFormContainerControl('rechazo', 'rechazo');

	const configAction: ActionButtonConfig[] = config.map((values) => {
		return {
			buttonBackName: values.buttonBackName,
			buttonNextName: values.buttonNextName,
			buttonBackClick: () => {
				executeAction(values.backAction, { ...formData, flow: 'REFINANCIAMIENTO', trafficSources: sessionStorage.getItem('trafficSources') });
			},
			buttonNextClick: () => {
				executeAction(values.nextAction, { ...formData, flow: 'REFINANCIAMIENTO', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		} as ActionButtonConfig;
	});

	useEffect(
		() => {
			setShowLoadingModal(true);
			login(
				() => setShowLoadingModal(false),
				() => history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`)
			);
		},
		//eslint-disable-next-line
		[]
	);

	const classContainer = checkIsMobile()
		? 'portabilidad-container'
		: 'portabilidad-container card-box';

	return (
		<div className={classContainer}>
			<FormContext.Provider
				value={{
					setError: setEnableButton,
					setData: setformData,
					//storage: storageService,
				}}
			>
				<LoadingModal showLoadingModal={showLoadingModal} isLongTime={showLongModal} />

				<StageBar value={step + 1} maxValue={configAction.length} />

				{
					{
						0: (
							<RefinancingPersonalInfoForm
								dataLayerKey={DATA_LAYER_RESPONSE_KEY.REFINANCING_INFO_PERSONAL}
							/>
						),
						1: (
							<RefinancingVehicleForm
								dataLayerKey={DATA_LAYER_RESPONSE_KEY.REFINANCING_INFO_VEHICULO}
							/>
						),
					}[step]
				}

				<ControlLayout
					inputError={enableButton}
					handleBackClick={configAction[step].buttonBackClick}
					handleNextClick={configAction[step].buttonNextClick}
					buttonBackName={configAction[step].buttonBackName}
					buttonNextName={configAction[step].buttonNextName}
				/>
			</FormContext.Provider>
		</div>
	);
};
